import React from "react";
import styled from "styled-components";
import { letterSpacing } from "styled-system";
import { Text } from "rebass";

const H3 = styled(Text)`
  ${letterSpacing};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

H3.defaultProps = {
  is: "h3",
  m: 0,
  color: "text",
  fontSize: 4,
  fontWeight: "bold",
  lineHeight: 2,
  letterSpacing: "headings"
};

export default H3;



// WEBPACK FOOTER //
// ./src/components/Headings/H3.js